import { render, staticRenderFns } from "./CheckoutB2C.vue?vue&type=template&id=8e126d7c&"
import script from "./CheckoutB2C.ts?vue&type=script&lang=ts&"
export * from "./CheckoutB2C.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports